import script from "./LingoStudentSpellingListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoStudentSpellingListView.vue?vue&type=script&setup=true&lang=ts"

import "./LingoStudentSpellingListView.vue?vue&type=style&index=0&id=7d509a36&lang=scss&scoped=true"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d509a36"]])

export default __exports__